<template>
  <li><span :class="{checked:cheked}" @click="handleClick($event)" :data-id="dataId" :data-num="stockNumber">{{stockNumber}}</span></li>
</template>
 
<script type="text/ecmascript-6">
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    stockNumber:{
      type:String,
      default:''
    },
    dataId:{
      type:String,
      default:''
    }
  },
   watch: {
		n() {
      this.cheked = false
		}
  },
  data () {
    return {
      cheked:false

    };
 },
 methods:{
   handleClick(e){
     this.cheked = !this.cheked
     let stockFid = e.target.attributes['data-id'].value
     let stockNumber = e.target.attributes['data-num'].value
     this.$emit('check-change', {stockFid,stockNumber,checked:this.cheked})
    },
 }
}
</script>
 
<style lang="css" scoped>
 li {
  display: inline-block;
  text-align: center;
  width: calc(100% / 6);
  box-sizing: border-box;
  padding-left: 16px;
  padding-bottom: 16px;
}
li span {
  width:100%;
  display: inline-block;
  border: 1px solid #DDDEE1;
  border-radius: 2px;
  line-height: 28px;
  cursor: pointer;
}
li  span.checked {
 border: 1px solid #CFA868;
}
</style>